<template>
  <div class="my-work">
    <div class="box">
      <div class="title">
        <img src="@/assets/index/joinParty/dp-lc1-icon2.png" alt />
        我的工作
      </div>
      <div class="content" v-if="text=='text'">
        <div class="content-template">
          <button @click="goJoinPartyApply" v-if="button0">{{button0Text}}</button>
          <p v-text="data.title" v-for="data in datas" :key="data.title"></p>
        </div>
      </div>
      <div class="list" v-if="text=='video'">
        <div class="list-template" v-for="list in lists" :key="list.title">
          <img :src="list.imgUrl" alt />
          <div class="text">
            <p v-text="list.title"></p>
            <p>活动时间:{{list.active}}</p>
            <button @click="goVideo(list)">查看详情</button>
          </div>
        </div>
      </div>

      <div class="active" v-if="text=='active'">
        <div class="active-template" v-for="(active,index) in actives" :key="index">
          <img :src="active.images | filterC" alt />
          <div class="text">
            <p v-text="active.Title"></p>
            <p>活动时间:{{active.time | times}}</p>
            <button @click="goRoom(active)">查看详情</button>
          </div>
        </div>
      </div>

      <div class="upload" v-if="name==21 || name==13">
        <div v-for="imgUrl in imgUrls" :key="imgUrl.img">
          <img v-if="imgUrl.img" :src="imgUrl.img" alt class="showImg" />
        </div>
        <img src="@/assets/index/joinParty/dp-lc1-ph.png" @click="addImg" />
        <input style="display: none" id="input" type="file" class="inputs" />
        <p>上传纸质版入党申请书</p>
        <button @click="subImg(name)">点击提交</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [
        { title: "填写入党申请书。" },
        { title: "注意接收信息，等待管理员审核入党申请书。" }
      ],
      lists: [
        {
          imgUrl: require("@/assets/index/joinParty/dp-lc1-icon1.png"),
          title: "观看党建政治学习视频",
          active: "2019.11.08"
        }
      ],
      actives: [],
      button0: false,
      text: "text",
      imgUrls: [],
      button0Text: "填写入党申请书",
      nextButton: false
    };
  },
  name: "myWork",
  props: {
    name: Number
  },
  methods: {
    goJoinPartyApply() {
      this.$router.push({
        path: "/index/joinparty/apply",
        query: { title: this.button0Text, verify: this.nextButton }
      });
    },
    goRoom(title) {
      console.log(title);
      
      let sourecLink = {
        Vid:title.id,
        VideoPath:title.url
      }
      if (title.checkid === 2) {
          this.$router.push({
        path: "/boutique/videoPlayer",
        query: { title: "视频播放", source: JSON.stringify(sourceLink) }
      });
      } else {
        if (title === "观看党建政治学习视频") {
          this.$router.push({ path: "/index/joinparty/videolist" });
          return;
        }
        this.$parent.shows = 3;
        this.$parent.junior = title;
      }
    },
    getMsg() {
      this.datas = [];
      this.axios
        .get(`/api/Index/GetMywork?stateid=${this.name + 1}`)
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              if (e.data.msg.stateid == 1) {
                this.button0 = true;
              }
              let arrays = e.data.msg.text.split("；");
              arrays.filter(item => {
                this.datas.push({ title: item });
              });
              break;

            default:
              break;
          }
        });
    },
    getVideo() {
      this.axios
        .get(
          `/api/Index/GetActivity?stateid=${this.name +
            1}&branchID=${sessionStorage.getItem("pmbid")}`
        )
        .then(e => {
          console.log(e.data);
        });
    },
    addImg(event) {
      let imgLength = document.getElementsByClassName("showImg")[
        document.getElementsByClassName("showImg").length - 1
      ];
      let input = document.querySelector(".inputs");
      input.click(); //点击添加事件
      input.onchange = () => {
        var preview = imgLength; //这里是img,调用遍历 寻找dom的类 展示用
        var file = input.files[0]; //得到上传的图片路径
        var reader = new FileReader(); //把file路径转换
        if (file) {
          reader.readAsDataURL(file);
        } else {
          //   preview.src = "";
        }
        reader.onloadend = () => {
          if (reader.result.length / 1380 > 2000) {
            alert("文件太大,请重新上传");
          } else {
            this.imgUrls.push({ img: reader.result });
          }
        };
      };
    },
    getActive() {
      this.axios
        .get(
          `/api/Index/GetActivity?stateid=${this.name +
            1}&branchID=${sessionStorage.getItem("tempBranchId") * 1}
            &userid=${sessionStorage.getItem("id")}`
        )
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.actives = e.data.msg;
              break;

            default:
              break;
          }
        });
    },
    sign(value) {
      //房间签到或者创建房间
      console.log(value);
    },
    subImg(value) {
      if (this.imgUrls.length == 0) {
        alert("图片不能为空");
        return;
      }
      let url,
        data,
        imgString = "";

      this.imgUrls.filter(item => {
        imgString = imgString + item.img.replace(/data(\S*?)base64,/, "") + ";";
      });
      // console.log(imgString);

      if (value == 13) {
        url = "/api/Index/PutVolunt";
        data = {
          voluntimg: imgString,
          stateid: this.name + 1,
          userid: sessionStorage.getItem("id")
        };
      } else {
        url = "/api/Index/Putforma";
        data = {
          formalimg: imgString,
          userid: sessionStorage.getItem("id"),
          stateid: this.name + 1
        };
      }
      this.axios.post(url, data).then(e => {
        // console.log(e.data);
        switch (e.data.code) {
          case 0:
            alert("添加成功");
            break;

          default:
            alert(e.data.msg);
            break;
        }
      });
    },
    amend() {
      this.axios
        .get("/api/Index/GetUserSum?userid=" + sessionStorage.getItem("id"))
        .then(e => {
          switch (e.data.code) {
            case 0:
              this.button0Text = "修改入党申请书";
              this.nextButton = true;
              break;
            default:
              break;
          }
        });
    }
  },
  mounted() {
    if (this.name == 0) this.amend();
    if (this.name == 5 || this.name == 19 || this.name == 10) {
      this.getActive();
      this.text = "active";
    } else {
      this.getMsg();
      this.text = "text";
    }
  },
  filters: {
    filterC: function(value) {
      if (value != "" && value != undefined) {
        return value.indexOf("http") > -1
          ? value
          : `http://dpinterface.djplus.cn/Partyimg/${value}`;
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.my-work {
  .box {
    .active {
      .active-template {
        .text {
          p {
            &:nth-child(2) {
              color: #999999;
            }
            &:nth-child(1) {
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
            }
          }
          button {
            padding: 0.1rem 0.2rem;
            border: none;
            font-size: 0.26rem;
            color: #fff;
            border-radius: 0.08rem 0.16rem 0.08rem 0.16rem;
            background: #ea5e63;
            position: absolute;
            right: 0.1rem;
            bottom: 0.3rem;
          }
          width: 100%;
          border-bottom: 0.01rem solid #eeeeee;
          position: relative;
          padding-bottom: 0.2rem;
        }
        img {
          width: 1.2rem;
          height: 1.2rem;
          border-radius: 0.04rem;
          margin-right: 0.2rem;
        }
        display: flex;
        padding: 0 0.2rem;
        margin-bottom: 0.2rem;
      }
    }

    .list {
      .list-template {
        .text {
          p {
            &:nth-child(2) {
              color: #999999;
            }
            &:nth-child(1) {
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
            }
          }
          button {
            padding: 0.1rem 0.2rem;
            border: none;
            font-size: 0.26rem;
            color: #fff;
            border-radius: 0.08rem 0.16rem 0.08rem 0.16rem;
            background: #ea5e63;
            position: absolute;
            right: 0.1rem;
            bottom: 0.3rem;
          }
          width: 100%;
          border-bottom: 0.01rem solid #eeeeee;
          position: relative;
          padding-bottom: 0.2rem;
        }
        img {
          width: 1.2rem;
          height: 1.2rem;
          border-radius: 0.04rem;
          margin-right: 0.2rem;
        }

        display: flex;

        padding: 0.2rem;
      }
    }
    .content {
      button {
        position: absolute;
        right: 1rem;
        top: 0rem;
        padding: 0.1rem 0.2rem;
        font-size: 0.3rem;
        color: #fff;
        border: none;
        border-radius: 0.08rem;
        background: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
      }
      span {
        position: absolute;
        right: 1rem;
        top: 0.3rem;
        color: #1095fc;
      }
      .content-template {
        p {
          line-height: 2;
        }
        padding: 0 0.2rem;
      }
      position: relative;
    }

    .upload {
      button {
        position: absolute;
        right: 0.2rem;
        top: 0.1rem;
        border: none;
        color: #fff;
        background: #f9b94d;
        padding: 0.1rem 0.2rem;
        font-size: 0.28rem;
        border-radius: 0.08rem;
      }
      p {
        position: absolute;
        top: 0.2rem;
        color: #999999;
      }
      margin-top: 0.2rem;
      padding: 0.2rem;
      background: #fff;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      img {
        width: 1.46rem;
        height: 1.46rem;
        margin: 0.5rem 0.2rem 0 0;
      }
      position: relative;
    }

    .title {
      img {
        width: 0.48rem;
        height: 0.48rem;
        border-radius: 50%;
        margin: 0.2rem;
      }

      display: flex;
      align-items: center;
      line-height: 3;
    }
    width: 94%;
    margin: 0 auto;
    background: #fff;
    border-radius: 0.08rem;
    font-size: 0.3rem;
    border-top: solid 0.2rem #f9f9f9;
  }
}
</style>